import { useAllUsers } from '../../app-users/hooks/use-all-users.query';
import {
  settingsUsersSearchPhraseState,
  settingsUsersSortState,
} from '../../settings/settings.state';
import type { AllUsersQueryParams } from '@/api/v4/user.api';
import { QueryKey } from '@/config/query-client';
import { useQueryClient } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';

export const useActiveAndDisabledUsers = () => {
  const queryClient = useQueryClient();

  const sortState = useAtomValue(settingsUsersSortState);
  const sort = sortState?.sort;
  const direction = sortState?.direction;
  const search = useAtomValue(settingsUsersSearchPhraseState);

  const params: AllUsersQueryParams = {
    sort,
    direction,
    ...(search && { search }),
    statuses: ['active', 'disabled'],
  };

  const { data, isLoading } = useAllUsers(params);

  const refreshUsers = () =>
    queryClient.invalidateQueries({ queryKey: [QueryKey.UsersAll, params] });

  const users = data ?? [];

  return { users, isLoading, refreshUsers };
};
